export const changeSidebarSubMenus = (subMenus) => (dispatch) => {
  dispatch({
    type: 'CHANGE_SIDEBAR_SUBMENUS',
    payload: subMenus,
  })
}
